import Button from './Button'

export default {
  Button,
  // ... other components
}
